import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {A11yModule} from '@angular/cdk/a11y';
import {SharedModule} from '@app/modules/shared/shared.module';
import {NavHeaderComponent} from './nav-header/nav-header.component';
import {NavTopMenuComponent} from './nav-top-menu/nav-top-menu.component';
import {NavSidebarComponent} from './nav-sidebar/nav-sidebar.component';
import {NavProjectSwitcherComponent} from './nav-project-switcher/nav-project-switcher.component';
import {NavMenuSearchComponent} from './nav-menu-search/nav-menu-search.component';
import {NavCommandPaletteComponent} from './nav-command-palette/nav-command-palette.component';
import {NavBreadcrumbComponent} from './nav-breadcrumb/nav-breadcrumb.component';
import {NavToolbarComponent} from './nav-toolbar/nav-toolbar.component';
import {NavUserMenuComponent} from './nav-user-menu/nav-user-menu.component';

/**
 * The panel's navigation: the header (top menu or breadcrumb bar), the side menu, menu search
 * and its Ctrl/Cmd+K palette. What they show comes from the server with every sign-in
 * (NavigationStateService); how they are laid out, from NavLayoutService.
 */
@NgModule({
  declarations: [
    NavHeaderComponent,
    NavTopMenuComponent,
    NavSidebarComponent,
    NavProjectSwitcherComponent,
    NavMenuSearchComponent,
    NavCommandPaletteComponent,
    NavBreadcrumbComponent,
    NavToolbarComponent,
    NavUserMenuComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    A11yModule,
    SharedModule,
  ],
  exports: [
    NavHeaderComponent,
    NavSidebarComponent,
    NavCommandPaletteComponent,
    NavBreadcrumbComponent,
    NavMenuSearchComponent,
  ],
})
export class NavigationModule {
}
